// src/components/Header/headerConfig.ts
export const headerConfig: Record<string, {
  showSearch: boolean;
  gridClass: string;
  titleClass: string;
  extraRight?: "menu" | "imetanicLogo" | null;
}> = {
  Laundry: {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "text-2xl font-bold",
    extraRight: "menu",
  },
  Saloon: {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "text-xl font-bold",
    extraRight: "menu",
  },
  Restaurant: {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "text-2xl font-bold",
    extraRight: "menu",
  },
  Carwash: {
    showSearch: false,
    gridClass: "car-grid-container",
    titleClass: "text-xl font-bold",
    extraRight: "imetanicLogo",
  },
  "Car wash": {
    showSearch: false,
    gridClass: "car-grid-container",
    titleClass: "text-xl font-bold",
    extraRight: "imetanicLogo",
  },
  "Vechicle retailer": {
    showSearch: false,
    gridClass: "grid-container",
    titleClass: "text-xl font-bold",
    extraRight: "imetanicLogo",
  },
};
